import { IConciergeEmbedChat, IFeatureToggles } from 'interfaces/concierge';
import React, { useEffect, useLayoutEffect } from 'react';

declare var embedded_svc: any;

export interface IConciergeEmbedChatProps {
  data: IConciergeEmbedChat;
  featureToggles: IFeatureToggles;

}

const LiveChat = ({ data, featureToggles }: IConciergeEmbedChatProps): JSX.Element => {
  useLayoutEffect(() => {
    if (!document.body.classList.contains('embed-chat-active')) {
      //Some documentation for this parameters and some extra tools usable in js can be found in https://developer.salesforce.com/docs/atlas.en-us.snapins_web_dev.meta/snapins_web_dev/snapins_web_overview.htm
      document.body.classList.add('loading-embed-chat');
      var defaultTopic = 'Reserve & Deposit';
      var initiatedFrom = 'Reserve & Deposit Page';
      var initESW = function (gslbBaseURL: any) {
        embedded_svc.settings.prepopulatedPrechatFields = {};
        embedded_svc.settings.prepopulatedPrechatFields.Chat_Topic__c =
          defaultTopic;
        embedded_svc.settings.extraPrechatFormDetails = [
          {
            label: 'InitiatedFrom',
            value: initiatedFrom,
            displayToAgent: true,
          },
        ];
        embedded_svc.settings.prepopulatedPrechatFields = {
          FirstName: '',
          LastName: '',
          Email: '',
          Phone_1__c: '',
          CustomerId__c: '',
        };
        embedded_svc.settings.extraPrechatInfo = [
          {
            entityFieldMaps: [
              {
                doCreate: false,
                doFind: false,
                fieldName: 'LastName',
                isExactMatch: true,
                label: 'Last Name',
              },
              {
                doCreate: false,
                doFind: false,
                fieldName: 'FirstName',
                isExactMatch: true,
                label: 'First Name',
              },
              {
                doCreate: false,
                doFind: false,
                fieldName: 'Email',
                isExactMatch: true,
                label: 'Email',
              },
            ],
            entityName: 'Contact',
          },
          {
            entityFieldMaps: [
              { doCreate: false, fieldName: 'Subject', label: 'Subject' },
              {
                doCreate: false,
                fieldName: 'CustomerId',
                label: 'CustomerId__c',
              },
              {
                doCreate: false,
                fieldName: 'Chat_Sub_Topic__c',
                label: 'Topic',
              },
            ],
            entityName: 'Case',
          },
        ];
        // Salesforce documentation https://developer.salesforce.com/docs/atlas.en-us.snapins_web_dev.meta/snapins_web_dev/embedded_web_prechat_functionality.htm

        embedded_svc.settings.displayHelpButton = true; //Or false
        embedded_svc.settings.language = ''; //For example, enter 'en' or 'en-US'
        embedded_svc.settings.defaultMinimizedText = data.defaultMinimizedText; //(Defaults to Chat with an Expert)
        embedded_svc.settings.offlineSupportMinimizedText =
          data.offlineSupportMinimizedText; //(Defaults to Contact Us)
        embedded_svc.settings.loadingText = data.loadingText; //(Defaults to Loading)
        embedded_svc.settings.storageDomain = data.storageDomain; //(Sets the domain for your deployment so that visitors can navigate subdomains during a chat session)
        embedded_svc.settings.enabledFeatures = ['LiveAgent'];
        embedded_svc.settings.entryFeature = 'LiveAgent';
        embedded_svc.addEventHandler(
          'onSettingsCallCompleted',
          function (data: any) {
            document.body.classList.remove('loading-embed-chat');
            document.body.classList.add('embed-chat-active');
          }
        );
        embedded_svc.init(
          data.embeddedChatSalesforceBaseLink,
          `${data.salesforceSitesUrlBaseLink}/service`,
          gslbBaseURL,
          data.conciergeAgentServiceId,
          'Concierge',
          {
            baseLiveAgentContentURL: `${data.conciergeAgentUrlContentBaseLink}/content`,
            deploymentId: data.conciergeDeploymentId,
            buttonId: data.conciergeButtonId,
            baseLiveAgentURL: `${data.conciergeAgentUrlBaseLink}/chat`,
            eswLiveAgentDevName: 'Concierge',
            isOfflineSupportEnabled: true,
          }
        );
      };
      if (!(window as WindowNewConcierge & typeof globalThis).embedded_svc) {
        var s = document.createElement('script');
        s.setAttribute(
          'src',
          `${data.embeddedChatSalesforceBaseLink}/embeddedservice/5.0/esw.min.js`
        );
        s.onload = function () {
          initESW(null);
        };
        document.body.appendChild(s);
      } else {
        initESW('https://service.force.com');
      }
      (function () {
        let xmlreq = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function () {
          this.addEventListener('load', (_loadEvent) => {
            const inputElement = document.querySelector(
              '#CustomerId__c'
            ) as HTMLElement;
            if (inputElement != null) {
              inputElement.style.display = 'none';
            }
            const labelElement = document.querySelector(
              '#CustomerId__c-label'
            ) as HTMLElement;
            if (labelElement != null) {
              labelElement.style.display = 'none';
            }

            let firstName = document.querySelector(
              '#First_Name__c'
            ) as HTMLInputElement;
            if (firstName != null) {
              firstName.value =
                embedded_svc.settings.prepopulatedPrechatFields.FirstName;
              firstName.dispatchEvent(new Event('change', { '': !0 }));
            }
            let lastName = document.querySelector(
              '#Last_Name__c'
            ) as HTMLInputElement;
            if (lastName != null) {
              lastName.value =
                embedded_svc.settings.prepopulatedPrechatFields.LastName;
              lastName.dispatchEvent(new Event('change', { '': !0 }));
            }
            let phone = document.querySelector(
              '#Phone_1__c'
            ) as HTMLInputElement;
            if (phone != null) {
              phone.value =
                embedded_svc.settings.prepopulatedPrechatFields.Phone_1__c;
              phone.dispatchEvent(new Event('change', { '': !0 }));
            }
            let custid = document.querySelector(
              '#CustomerId__c'
            ) as HTMLInputElement;
            if (custid != null) {
              custid.value =
                embedded_svc.settings.prepopulatedPrechatFields.CustomerId__c;
              custid.dispatchEvent(new Event('change', { '': !0 }));
            }
            let email = document.querySelector(
              '#Email_1__c'
            ) as HTMLInputElement;
            if (email != null) {
              email.value =
                embedded_svc.settings.prepopulatedPrechatFields.Email;
              email.dispatchEvent(new Event('change', { '': !0 }));
            }
          });
          xmlreq.apply(this, arguments as any);
        };
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (featureToggles.conciergeChatUpdatedStylesEnabled) {
      document.body.classList.add('updated-concierge-styles');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return <></>;
};

export default LiveChat;
